import { defineStore } from "pinia";
import {
    getLastForecast,
    getForecastModelStatus,
    getForecastTableByAssetId,
    getBasinConditionsByAssetId,
    getForecastBarChartByAssetId,
} from "@/utils/api.js";
import { Notify } from 'quasar';

export const defaultState = () => ({
    lastForecast: '',
    nextForecast: '',
    ensembleInProgress: false,
    modelStatusLoaded: false,
    rainModelStatus: [],
    snowModelStatus: [],
    basinConditions: {},
    dailyForecasts: {},
    modelForecasts: {},
    forecastThresholds: {},
    gaugeThresholds: {},
    hourlyForecasts: {},
    watersheds: {},
});

export const useForecastStore = defineStore("forecast", {

    state: defaultState,
    actions: {
        async initializeForecastStore() {
            if (this.lastForecast === '' || this.nextForecast === '') {
                const ensembleSchedule = await getLastForecast();
                this.lastForecast = ensembleSchedule.ensembleRanAt;
                this.nextForecast = ensembleSchedule.nextPlanned;
                this.ensembleInProgress = ensembleSchedule.ensembleInProgress;
            }
            const forecastModelResponse = await getForecastModelStatus();
            this.rainModelStatus = forecastModelResponse.rainModelStatus;
            this.snowModelStatus = forecastModelResponse.sweModelStatus;
            this.modelStatusLoaded = true;
        },
        async getForecastData(id) {
            try {
                const [tableResponse, chartResponse, basinResponse] = await Promise.all([
                    getForecastTableByAssetId(id), getForecastBarChartByAssetId(id), getBasinConditionsByAssetId(id)
                ]);
                this.dailyForecasts[id] = tableResponse.dailyTimeSeries;
                this.modelForecasts[id] = tableResponse.modelDailyTimeSeries;
                this.hourlyForecasts[id] = chartResponse;
                this.basinConditions[id] = basinResponse;
            } catch (e) {
                console.error(e);
                Notify.create({ message: 'There was a problem getting the forecast for this location. Please try again later.', type: 'negative' });
            }
        },
        clear() {
            this.$reset();
        },
    },
});
